import React from "react";
import PropTypes from "prop-types";

export const FavoriteStarIcon = ({
  active = false,
  color,
  size = 20,
  className = "",
  ...props
}) => {
  const fillColor = color || (active ? "#F6BA47" : "#5D5D5D");

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M12.962 4.59625L14.904 8.51324C15.05 8.80824 15.332 9.01226 15.659 9.05926L20.1419 9.70721C20.9639 9.82621 21.292 10.8342 20.697 11.4122L17.456 14.5572C17.219 14.7872 17.111 15.1182 17.167 15.4432L17.9079 19.7473C18.0579 20.6203 17.1409 21.2862 16.3549 20.8752L12.467 18.8403C12.175 18.6873 11.827 18.6873 11.536 18.8403L7.65096 20.8732C6.86396 21.2852 5.94393 20.6182 6.09493 19.7432L6.83602 15.4432C6.89202 15.1182 6.78396 14.7872 6.54696 14.5572L3.30599 11.4122C2.70999 10.8342 3.03792 9.82621 3.86092 9.70721L8.34395 9.05926C8.66995 9.01226 8.95196 8.80824 9.09896 8.51324L11.041 4.59625C11.432 3.80125 12.568 3.80125 12.962 4.59625Z"
        fill={fillColor}
      />
    </svg>
  );
};

FavoriteStarIcon.propTypes = {
  active: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
};

export default FavoriteStarIcon;
